import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { Hidden } from '@material-ui/core';
import { Drawer } from '@material-ui/core';
import DrawerMenu from './DrawerMenu';
import { observer } from 'mobx-react';
import { EmployeeDto } from '../pages/user/userTypes';
import { IObservableValue } from 'mobx';
import { appTheme } from '../styles/appTheme';

const drawerWidth = 240;

type LocalStyles = 'drawerPaper' | 'drawerDocked';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  drawerPaper: {
    width: drawerWidth,
    height: '100%',
    [theme.breakpoints.up('md')]: {
      position: 'relative',
    },
  },
  drawerDocked: {
    height: '100%',
  },
});

interface Props {
  selfAccount: EmployeeDto;
  mobileOpen: boolean;
  handleDrawerToggle: () => void;
  resetSearch: () => void;
  currentRouteIndex: IObservableValue<number>;
}

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class MyDrawer extends React.Component<PropsWithStyle, {}> {

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    const {classes} = this.props;

    return (
      <div>
        <Hidden mdUp={true}>
          <Drawer
            variant="temporary"
            open={this.props.mobileOpen}
            onClose={this.props.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            anchor={appTheme.direction === 'rtl' ? 'right' : 'left'}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <DrawerMenu resetSearch={this.props.resetSearch} currentRouteIndex={this.props.currentRouteIndex}
                        selfAccount={this.props.selfAccount} handleDrawerToggle={this.props.handleDrawerToggle}
                        mobileOpen={this.props.mobileOpen}
            />
          </Drawer>
        </Hidden>
        <Hidden smDown={true} implementation="js">
          <Drawer
            variant="permanent"
            open={true}
            classes={{
              paper: classes.drawerPaper,
              docked: classes.drawerDocked,
            }}
          >
            <DrawerMenu resetSearch={this.props.resetSearch} currentRouteIndex={this.props.currentRouteIndex}
                        selfAccount={this.props.selfAccount} handleDrawerToggle={this.props.handleDrawerToggle}
                        mobileOpen={this.props.mobileOpen}
            />
          </Drawer>
        </Hidden>
      </div>
    )
  }
}

export default withStyles(localStyles)(MyDrawer);
